export default __webpack_public_path__ + "resources/icons/n442-4aa4.png";